import React from "react";
import "../../../../../Assets/Styles/DeleteAlert.scss";

const MultipleDelete = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <React.Fragment>
      {props.IsDelete ? (
        <div
          className={
            window.localStorage.getItem("MenuIsOpen") === "1"
              ? "alert-overlay"
              : "alert-overlay alert-overlay-big"
          }
        >
          <div
            className="outline"
            onClick={() => props.cancelDeleteMultiple()}
          ></div>
          <div className="alert-body">
            <section className="alert-head">
              <p className="title">{translateText("delete_item")}</p>
              <button onClick={() => props.cancelDeleteMultiple()}>
                <i className="feather-x"></i>
              </button>
            </section>
            <p className="alert-text">
              {translateText("multiple_delete_text")}
            </p>
            <div className="delete-footer">
              <button
                className="cancel-btn"
                onClick={() => props.cancelDeleteMultiple()}
              >
                {translateText("cancel")}
              </button>
              <button
                className="delete-btn"
                onClick={() => props.acceptDeleteMultiple()}
              >
                {translateText("delete")}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default MultipleDelete;
